module.exports = __webpack_public_path__ + "img/banner.4cc2937e.png";